import { IconInfoCircle } from '@tabler/icons-react';
import { Card } from '@zorro/design-system/v2/Card';
import { Box, Group, Icon, Text } from '@zorro/web/design-system';

const CombinedNotice = () => {
  return (
    <Card variant="grey" px="md" py="lg">
      <Group gap="xs" wrap="nowrap" align="flex-start">
        <Box>
          <Icon icon={IconInfoCircle} />
        </Box>
        <Text>
          Use this when combining a standard plan with a special plan (e.g.,
          Medicare or student plan). The external plan premium is self-paid, and
          the rest is processed through Zorro Pay.
        </Text>
      </Group>
    </Card>
  );
};

export { CombinedNotice };
